import { defineStore } from 'pinia'

export const useServerSideData = defineStore('serverSideData', {
    state() {
        return {
            listSubCategoriesBannerIndex: 0,
        }
    },
    actions: {
        setListSubCategoriesBannerIndex(index: number) {
            this.listSubCategoriesBannerIndex = index
        },
    },
})
